import React from "react";
import ReactTooltip from "react-tooltip";

import "./SummaryBox.css";

function SummaryBox(props) {
  return (
    <div className="summary-box">
      <div className="summary-box--title">{props.title}</div>
      <div>
        <span className="summary-box--number">{props.value}</span> {props.noun}
        <span>
          <img
            src="images/info-icon.png"
            alt="more information"
            data-tip={props.tooltipText}
          />

          <ReactTooltip multiline={true} />
        </span>
      </div>
    </div>
  );
}

export default SummaryBox;
